import { Component, OnInit, OnDestroy } from '@angular/core';
import { Route, ActivatedRoute, Params, Router } from '@angular/router';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { ToolDescriptionService, ToolService, ToolNumberService, ToolTypeService } from '../../../camtl.service';
import { Tool } from '../../../../../shared/model';
import { CgpTreeviewService } from '../../../../../shared/cgp-treeview/cgp-treeview.service';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-stations',
  templateUrl: './stations.component.html',
  // styleUrls: ['./stations.component.scss']
})
export class StationsComponent implements OnInit, OnDestroy {

  constructor(
    private service: ToolService,
    private toolTypeService: ToolTypeService,
    private formBuilder: FormBuilder,
    private systemSelectService: SystemSelectService,
    private routeParams: ActivatedRoute,
    private cgpTreeviewService: CgpTreeviewService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private routeValidationService: RouteValidationService
  ) {
  }

  parentType: any;
  parentName: any;
  grandParentQuery: string = "";
  urlEnd: any;
  editForm: FormGroup;
  editDataItem: Tool;
  system: any;
  toolTypeId: string = undefined;
  stationId: string;
  dataSource: any;
  selected: any;
  selectedRowId: any;
  selectedStationNumber: string;
  showAssignWindow: any;
  parentId: any;
  disableActions: boolean = false;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  ngOnInit() {
    var self = this;
    this.editForm = this.formBuilder.group({
      Id: [],
      CreatedBy: [],
      CreatedDate: [],
      SystemId: [""],
      StationNumber: ["", Validators.required],
      ToolTypeId: [],
      ParentId: [],
      ToolDescriptionId: [],
      JobNumber: []
    })

    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Stations')) {
          this.cgpTreeviewService.dataSource$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(dataSource => this.dataSource = dataSource);
          this.cgpTreeviewService.selected$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(selected => this.selected = selected);
          this.cgpTreeviewService.get();
          this.cgpTreeviewService.getSelected();
        }
        if (this.system && this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
          this.disableActions = true;
          this.template.controls.add = false;
          this.template.controls.edit = false;
          this.template.controls.delete = false;
        }
        else {
          this.disableActions = false;
          this.template.controls.add = true;
          this.template.controls.edit = true;
          this.template.controls.delete = true;
        }
      });

    this.systemSelectService.get();

    this.routeParams.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        this.parentId = params["ParentId"];
        if (this.parentId && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Stations') && this.parentId.includes('-')) {
          this.service.read("/" + this.parentId, true)
            .then(function (response) {
              switch (response[0].ToolTypeName.toString()) {
                case "System Layout":
                  self.parentType = "System Layout";
                  self.urlEnd = "SystemLayout";
                  break;
                case "Cell":
                  self.parentType = "Cell";
                  self.urlEnd = "Cells";
                  break;
                default:
                  break;
              }
              self.parentName = response[0].ToolDetail.ToolNumber;
              if (response[0].ParentId !== null) {
                self.grandParentQuery = "?ParentId=" + response[0].ParentId
              }
              else {
                self.grandParentQuery = "";
              }
              self.cgpTreeviewService.setSelected(response[0]);
            })
        }

      })

    this.routeParams.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        if (this.routeParams.snapshot.params["id"]) {
          this.stationId = this.routeParams.snapshot.params["id"];
        }
        else {
          this.stationId = "";
        }
      });



    this.changeTemplateService();
  }

  private columns: any[] = [
    {
      field: "StationNumber",
      title: "Station Number",
    }
  ];

  formDialog = {
    title: "Station",
    formControls: [
      {
        type: 'text',
        name: 'StationNumber',
        title: 'Station Number'
      }
    ]
  }

  getById = () => {
    var self = this;
    if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Stations')) {
      this.toolTypeService.read()
        .then(function (response: any) {
          self.toolTypeId = response.filter(function (item) {
            return item.Description.toUpperCase() === "STATION";
          })[0].Id;
        })
      return this.service.read("/" + this.stationId, true);
    }
  }

  isDisabled = (id) => {
    switch (id) {
      case "assignToolsToStation":
        return this.disableActions;
      case "add":
        if (!this.toolTypeId) {
          return true;
        }
        else {
          return false;
        }
      default:
        return false;
    }
  }


  changeTemplateService() {
    if (this.stationId) {
      this.template = {
        controls: {
          add: false,
          edit: true,
          delete: true,
          excel: true,
          width: 150,
          custom: this.customButtons,
          isDisabled: this.isDisabled
        },
        columns: this.columns,
        service: this.service,
        read: this.getById,
        fileName: "stations.xlsx",
        displayField: "StationNumber"
      }
    }
  }

  assignToolsToStation = (e, dataItem, service, system, callBackInputs) => {
    this.selectedRowId = dataItem.Id;
    this.selectedStationNumber = dataItem.StationNumber;
    this.showAssignWindow = true;
  }

  saveToolAssignment(dataItems) {
    var self = this;
    for (var i = 0; i < dataItems.length; i++) {
      this.service.save(dataItems[i], false).then(function () {
        if (i === dataItems.length) {
          self.showAssignWindow = false;
          self.cgpSnackbarService.showSnackbar({
            message: i === 1 ? "Tools has been assigned" : "Tools have been assigned",
            duration: 2000
          });
          self.systemSelectService.get();
        }
      });
    }
  }


  cancelToolAssignment(e) {
    this.showAssignWindow = false;
    this.selectedRowId = undefined;
  }


  customButtons = [
    {
      id: "assignToolsToStation",
      class: "fa fa-wrench",
      title: "Assign Tool(s)",
      callback: this.assignToolsToStation
    }
  ];

  getStationsByParentId = () => {
    var self = this;
    if (this.parentId && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Stations') && this.parentId.includes('-')) {
      this.toolTypeService.read()
        .then(function (response: any) {
          self.toolTypeId = response.filter(function (item) {
            return item.Description.toUpperCase() === "STATION";
          })[0].Id;
        })
      return this.service.read("/stations/" + this.parentId, true);
    }
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
      width: 150,
      custom: this.customButtons,
      isDisabled: this.isDisabled
    },
    columns: this.columns,
    service: this.service,
    read: this.getStationsByParentId,
    fileName: "stations.xlsx",
    displayField: "StationNumber"
  }

  setModelHandler() {
    this.editDataItem = new Tool();
    this.editDataItem.ParentId = this.parentId;
    this.editDataItem.MakeFurnish = "M";
    this.editDataItem.JobNumber = 0;

    if (this.system) {
      this.editDataItem.ToolTypeId = this.toolTypeId;
      this.editDataItem.SystemId = this.system.Id;
    }
  }

}
